import { styled } from 'styled-components';
import { colors } from '../../../abstracts';
export const DrawerFooterBorder = styled.div.withConfig({
  componentId: "aui__sc-1rtiiwh-0"
})(["box-sizing:border-box;width:100%;border-top:1px solid ", ";"], colors.neutralBrighter);